import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import './WatchOSGallery.css';

function WatchOSGallery() {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const watchMockups = [
    {
      id: 'main-scuba',
      src: `${process.env.PUBLIC_URL}/wosMainScuba.png`,
      title: 'Scuba Diving Mode',
      description: 'Complete scuba diving interface with depth tracking, decompression monitoring, and safety alerts right on your wrist'
    },
    {
      id: 'main-snorkeling',
      src: `${process.env.PUBLIC_URL}/wosMainSnorkeling.png`,
      title: 'Snorkeling Mode',
      description: 'Streamlined snorkeling interface for surface and shallow water activities with simplified metrics'
    },
    {
      id: 'active-scuba-1',
      src: `${process.env.PUBLIC_URL}/wosActiveScuba1.png`,
      title: 'Active Dive Interface',
      description: 'Real-time dive data display showing current depth, dive time, temperature, and critical safety information'
    },
    {
      id: 'active-scuba-2',
      src: `${process.env.PUBLIC_URL}/wosActiveScuba2.png`,
      title: 'Extended Dive Metrics',
      description: 'Advanced dive analysis features including NDL calculations, ascent rate monitoring, and tissue loading for post-dive analysis'
    },
    {
      id: 'active-snorkeling',
      src: `${process.env.PUBLIC_URL}/wosActiveSnorkeling.png`,
      title: 'Active Snorkeling',
      description: 'Live snorkeling session tracking with surface time, max depth reached, and session duration'
    },
    {
      id: 'dive-history',
      src: `${process.env.PUBLIC_URL}/wosDiveHistory.png`,
      title: 'Dive History',
      description: 'Quick access to your recent dives directly from your Apple Watch with key stats and summaries'
    }
  ];

  const handleImageClick = (mockup) => {
    setSelectedImage(mockup);
    setShowModal(true);
  };

  return (
    <>
      <section id="watchos-gallery" className="watchos-gallery-section bg-alt">
        <Container>
          <div className="watchos-gallery-header" data-aos="fade-up">
            <h2 className="watchos-gallery-title">Apple Watch Interface</h2>
            <p className="watchos-gallery-subtitle">
              Professional dive analysis and logging right on your wrist - no additional hardware needed
            </p>
          </div>

          <Row className="watchos-gallery-grid g-4">
            {watchMockups.map((mockup, index) => (
              <Col lg={4} md={6} sm={6} key={mockup.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="watch-mockup-card" onClick={() => handleImageClick(mockup)}>
                  <div className="watch-image-container">
                    <img
                      src={mockup.src}
                      alt={mockup.title}
                      className="watch-gallery-image"
                      loading="lazy"
                    />
                    <div className="watch-overlay">
                      <div className="watch-overlay-content">
                        <i className="fas fa-search-plus watch-overlay-icon"></i>
                        <span className="watch-overlay-text">View Details</span>
                      </div>
                    </div>
                  </div>
                  <div className="watch-info">
                    <h5 className="watch-title">{mockup.title}</h5>
                    <p className="watch-description">{mockup.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* <div className="mt-5" data-aos="fade-up">
            <div className="watch-cta">
              <h4 className="watch-cta-title">
                Professional Dive Computer on Your Wrist
              </h4>
              <p className="watch-cta-description">
                Enhance your diving experience - your Apple Watch becomes a professional-grade dive logging and analysis tool
              </p>
              <a 
                href="#download" 
                className="watch-cta-button"
              >
                <i className="fab fa-apple watch-cta-button-icon"></i>
                Get ZDIVE for Apple Watch
              </a>
            </div>
          </div> */}
        </Container>
      </section>

      {/* Modal for enlarged view */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        className="watch-modal"
      >
        <Modal.Header closeButton className="watch-modal-header">
          <Modal.Title>{selectedImage?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="watch-modal-body">
          {selectedImage && (
            <>
              <img 
                src={selectedImage.src} 
                alt={selectedImage.title}
                className="watch-modal-image"
              />
              <div className="watch-modal-description-container">
                <p className="watch-modal-description">
                  {selectedImage.description}
                </p>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default WatchOSGallery;
